import * as Sentry from "@sentry/react";

const currentEnv =
  process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";
const sentryEnabledEnvs = ["staging", "production"];

if (sentryEnabledEnvs.includes(currentEnv)) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: currentEnv,
    tracesSampleRate: 0.4,
    debug: false
  })
}
